import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import {Avatar, Box, Button, ButtonBase, ButtonGroup, LinearProgress, Link, Toolbar, Typography} from '@mui/material';

// project imports
import Logo from 'ui-component/Logo';
import {styled} from "@mui/styles";
import {Trans} from 'react-i18next';
import defaultLanguage from 'i18n/defaultLanguage';
import { linearProgressClasses } from '@mui/material/LinearProgress';


// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === 'light' ? '#FF2C6D' : '#FF2C6D',
  }
}));

const Header = () => {
  const theme = useTheme();

  const handlerhome = () => {
    location.replace('/home');
  };

  const handlerdiscord = () => {
    window.location.href = 'https://discord.gg/uMg5R6qkXc';
  };

  const handlergallery = () => {
    location.replace('/square');
  };

  const handlerPaint = () => {
    location.replace('/paint')
  };

  const handlertutorial = () => {
    location.replace('/home');
  };

  return (
    <Toolbar
      sx={{
        height: '55px',
      }}
    >
      {/* logo & toggler button */}
      <Box display="flex" gap={3} alignItems="center">
        <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
          <Logo />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            '& > *': {
              m: 1,
            },
            marginTop: '3.5px'
          }}
        >
          <ButtonGroup aria-label="outlined button group">
          <Button sx={{ color:"#4D4D4D", ml:1}} variant="text" onClick={handlerhome}><Trans i18nKey="index.home">{ defaultLanguage.index.home }</Trans></Button>
          <Button sx={{ color:"#4D4D4D" }} variant="text" onClick={handlerPaint}><Trans i18nKey="index.generate">{ defaultLanguage.index.generate }</Trans></Button>
          <Button sx={{ color:"#4D4D4D"}} variant="text" onClick={handlergallery}><Trans i18nKey="index.gallery">{ defaultLanguage.index.gallery }</Trans></Button>
          <Box>
            <img
              style={{ position: 'relative', height: '12px', width: '16px', zIndex: '1', textAlign: 'right', float: 'right'}}
              src={"https://bkmk.oss-accelerate.aliyuncs.com/icon_ValentinesDay_pink.png?OSSAccessKeyId=LTAI5tPynodLHeacT1J5SmWh&Expires=317035943573&Signature=D%2Bwve%2BiLVdCl5weWc7eoHbDuYE0%3D"}
              alt={"https://bkmk.oss-accelerate.aliyuncs.com/icon_ValentinesDay_pink.png?OSSAccessKeyId=LTAI5tPynodLHeacT1J5SmWh&Expires=317035943573&Signature=D%2Bwve%2BiLVdCl5weWc7eoHbDuYE0%3D"}
            />
            <Button sx={{ color:"#FF2C6D", zIndex: 999, marginRight: -1.5}} variant="text" onClick={handlertutorial}><Trans i18nKey="index.velentine">{ defaultLanguage.index.velentine }</Trans></Button>
            <BorderLinearProgress
              variant="determinate"
              value={100}
              sx={{
                ml: 1,
                mr: 3,
                mt: -1,
                backgroundColor: '#FF2C6D ! important'
            }}/>
          </Box>
          <Button sx={{ color:"#4D4D4D" }} variant="text" onClick={handlerdiscord}><Trans i18nKey="index.discord">{ defaultLanguage.index.discord }</Trans></Button>
          </ButtonGroup>
        </Box>
      </Box>

    </Toolbar>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func
};

export default Header;
